import { render } from "./InvoiceCardSkeleton.vue?vue&type=template&id=6a9ab5be&scoped=true"
import script from "./InvoiceCardSkeleton.vue?vue&type=script&lang=js"
export * from "./InvoiceCardSkeleton.vue?vue&type=script&lang=js"

import "./InvoiceCardSkeleton.vue?vue&type=style&index=0&id=6a9ab5be&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9ab5be"]])

export default __exports__